import React, {Component} from 'react';
import {
  Row,
  Col,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap'
import moment from 'moment';

// const P1 = require('lopv5-constants');
const newRecord = require('../store/newRecord')
const R = require('ramda')
const STRING_LENGTH = 10;

class ShowRecords extends Component {

  constructor(props) {
    super(props);
    this.state = {
      activeOn: true,
      completedOn: false,
      showEditModal: false,
      recInEdit: null,
    }
    this.onActiveBtnClick = this.onActiveBtnClick.bind(this);
    this.onCompleteBtnClick = this.onCompleteBtnClick.bind(this);
    this.off = this.off.bind(this);
    this.on = this.on.bind(this);
    this.delete = this.delete.bind(this);
    this.edit = this.edit.bind(this);
    this.save = this.save.bind(this);
    this.cancel = this.cancel.bind(this);
    this.toggle = this.toggle.bind(this);
    this.newRec = this.newRec.bind(this);
    this.onChange = this.onChange.bind(this);
    this.isValid = this.isValid.bind(this);
  }

  getOnRecords(list) {
    if (list) {
      let count = R.countBy(rec => (rec.dateOff === 0) ? 'on' : 'off', list);
      return R.merge({on:'0', off:'0'}, count);
    } else {
      return {on:'0', off:'0'};
    }
  }

  onActiveBtnClick() {
    this.setState({activeOn: !this.state.activeOn});
  }

  onCompleteBtnClick() {
    this.setState({completedOn: !this.state.completedOn});
  }

  getRecInfo(evt) {
    let stuId = evt.currentTarget.getAttribute('data-id');
    let key = evt.currentTarget.getAttribute('data-key');
    return this.props.db.ref('records/'+stuId+'/'+key);
  }

  off(evt) {
    let ref = this.getRecInfo(evt);
    ref.update({dateOff: moment().unix(), dateOffWho: this.props.user.lastName+this.props.user.firstName});
    let stuId = evt.currentTarget.getAttribute('data-id');
    this.props.db.ref('students/'+stuId).update({lopCount: this.props.student.lopCount - 1});
  }

  on(evt) {
    let ref = this.getRecInfo(evt);
    ref.update({
      dateOff: 0,
      dateOffWho: ''
    });
    let stuId = evt.currentTarget.getAttribute('data-id');
    this.props.db.ref('students/'+stuId).update({lopCount: this.props.student.lopCount + 1});
  }

  delete(evt) {
    let _this = this;
    let ref = this.getRecInfo(evt);
    let stuID = evt.currentTarget.getAttribute('data-id');
    let key = evt.currentTarget.getAttribute('data-key');
    let rec = R.find(rec => rec.key === key, this.props.records)
    if (rec.dateOff+'' === '0') {
      this.props.db.ref('students/'+stuID).once('value', snap => {
        let stu = snap.val();
        _this.props.db.ref('students/'+stuID+'/lopCount').set(stu.lopCount-1);
      })
    }
    ref.remove();
  }

  edit(evt) {
    let idx = evt.currentTarget.getAttribute('data-idx');
    let recInEdit = R.clone(this.props.records[idx]);
    this.setState({
      showEditModal: true,
      recInEdit
    })
  }

  save(evt) {
    let _this = this;
    if (this.state.recInEdit.key === '') {
      this.props.db.ref('records/'+this.state.recInEdit.stuID).push(R.omit(['key'], this.state.recInEdit), error => {
        if (error) {
          console.log('error on push');
        } else {
          _this.setState({
            showEditModal: false
          })
        }
      })
      this.props.db.ref('students/'+this.state.recInEdit.stuID).update({lopCount: this.props.student.lopCount + 1});
    } else {
      this.props.db.ref('records/'+this.state.recInEdit.stuID+'/'+this.state.recInEdit.key).update(R.omit(['key'], this.state.recInEdit), error => {
        if (error) {
          console.log('error on update');
        } else {
          _this.setState({
            showEditModal: false
          })
        }
      })
      let oldRec = this.props.records[this.state.recInEdit.key]
      if (oldRec.off+'' === '0' && this.state.recInEdit.off > 0) {
        this.props.db.ref('students/'+this.state.recInEdit.stuID).update({lopCount: this.props.student.lopCount + 1});
      } else if (oldRec.off > '0' && this.state.recInEdit.off+'' === '0') {
        this.props.db.ref('students/' + this.state.recInEdit.stuID).update({lopCount: this.props.student.lopCount - 1});
      }
    }
  }

  cancel() {
    this.setState({showEditModal: false})
  }

  toggle() {
    this.setState({showEditModal: false})
  }

  newRec() {
    let recInEdit = newRecord();
    recInEdit.stuID = this.props.student.stuID;
    recInEdit.dateOn = moment().unix();
    recInEdit.contact = this.props.user.name;
    recInEdit.owner = this.props.user.lastName+this.props.user.firstName;
    recInEdit.notes = '';
    recInEdit.reason = R.find(it => it.reason === 'Tardy sweep', this.props.reasons).idx;
    this.setState({
      showEditModal: true,
      recInEdit
    })
  }

  isValid() {
    return this.state.recInEdit &&
      this.state.recInEdit.stuID.length > 0 &&
      this.state.recInEdit.dateOn > 0 &&
      this.state.recInEdit.contact.length > 0 &&
      this.state.recInEdit.reason !== ''
  }

  getReason(reasonList, reasonCode) {
    let r = R.find(reason => reason.idx+'' === reasonCode+'', reasonList);
    if (!r) {
      return "Unknown";
    } else {
      return r.reason;
    }
  }

  getDate(d) {
    if (d+'' === '0') {
      return '---';
    } else {
      return moment.unix(d).format('MM/DD/YYYY')
    }
  }

  onChange(evt) {
    let field = evt.currentTarget.getAttribute('name')
    let recInEdit = this.state.recInEdit;
    if (field === 'dateOn' || field === 'dateOff') {
      recInEdit[field] = (evt.currentTarget.value.length > 0) ? moment(evt.currentTarget.value).unix() : 0;
    } else {
      recInEdit[field] = evt.currentTarget.value;
    }
    this.setState({recInEdit})
  }

  generateLine(rec, idx, status) {
    let statusClass = (status === 'on') ? ' record-list-on-lop' : ' record-list-off-lop';
    let edit = this.props.user !== undefined && this.props.user.permissionFlags.EDIT_ALL === 'true';
    if (!edit) {
      if (this.props.user.permissionFlags.EDIT_OWN === 'true' &&
        rec.owner === this.props.user.lastName+this.props.user.firstName) {
        edit = true
      }
    }
    return (
      <ul key={'rec'+idx} className={'record-item'+statusClass}>
        <li className="date-on">
          {
            (edit) ?
              <h6>
                {
                  (rec.dateOff+'' === '0') ?
                    <span data-id={rec.stuID} data-key={rec.key} className={(edit) ? 'link' : ''} onClick={(edit) ? this.off : null}>Off</span> :
                    <span data-id={rec.stuID} data-key={rec.key} className={(edit) ? 'link' : ''} onClick={(edit) ? this.on : null}>On</span>
                }
                {'  '}
                <span data-id={rec.stuID} className={(edit) ? 'link' : ''} onClick={(edit) ? this.delete : null} data-key={rec.key}>Del</span>
                {'  '}
                <span data-id={rec.stuID} className={(edit) ? 'link' : ''} onClick={(edit) ? this.edit : null} data-key={rec.key} data-idx={idx}>Edit</span>
              </h6> :
              <h6>{' '}</h6>
          }
        </li>
        <li className="date-on center">
          <h6>{this.getDate(rec.dateOn)}</h6>
        </li>
        <li className="date-off center">
          <h6>{this.getDate(rec.dateOff)}</h6>
        </li>
        <li className="date-off center">
          <h6>{rec.notes}</h6>
          {/*<h6>{R.take(STRING_LENGTH, rec.dateOffWho)}</h6>*/}
        </li>
        <li className="reason center">
          <h6>{this.getReason(this.props.reasons, rec.reason)}</h6>
        </li>
        <li className="date-off center">
          <h6>{R.take(STRING_LENGTH, rec.contact)}</h6>
        </li>
      </ul>
    )
  }

  getEditModal() {
    if (!this.state.recInEdit) return null;
    let dateOff = (this.state.recInEdit.dateOff === 0) ? '' : moment.unix(this.state.recInEdit.dateOff).format('YYYY-MM-DD');
    let dateOn = (this.state.recInEdit.dateOn === 0) ? '' : moment.unix(this.state.recInEdit.dateOn).format('YYYY-MM-DD');
    return (
      <Modal isOpen={this.state.showEditModal} toggle={this.toggle}>
        <ModalHeader toggle={this.toggle}>Edit LOP Record</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup row>
              <Label for="owner" md={5}>Owner</Label>
              <Col md={7}>
                <Input type="text" name="owner" id="owner" value={this.state.recInEdit.owner} readOnly/>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="contact" md={5}>Contact</Label>
              <Col md={7}>
                <Input type="text" name="contact" id="contact" value={this.state.recInEdit.contact} onChange={this.onChange} />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="dateOn" md={5}>Date on</Label>
              <Col md={7}>
                <Input type="date" name="dateOn" id="dateOn" value={dateOn} onChange={this.onChange} />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="reason" md={5}>Reason</Label>
              <Col md={7}>
                <Input type="select" name="reason" id="reason" value={this.state.recInEdit.reason} onChange={this.onChange}>
                  {
                    this.props.reasons.map(r => <option key={'option'+r.idx} value={r.idx}>{r.reason}</option>)
                  }
                </Input>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="notes" md={5}>Notes</Label>
              <Col md={7}>
                <Input type="text" name="notes" id="notes" onChange={this.onChange} value={this.state.recInEdit.notes} />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="dateOff" md={5}>Date off</Label>
              <Col md={7}>
                <Input type="date" name="dateOff" id="dateOff" value={dateOff} onChange={this.onChange} />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="dateOffWho" md={5}>Who took off LOP?</Label>
              <Col md={7}>
                <Input type="text" name="dateOffWho" id="dateOffWho" value={this.state.recInEdit.dateOffWho} onChange={this.onChange} />
              </Col>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" disabled={!this.isValid()} onClick={this.save}>Save</Button>{' '}
          <Button color="secondary" onClick={this.toggle}>Cancel</Button>
        </ModalFooter>
      </Modal>
    )
  }

  render() {
    let _this = this;
    let countRecords = this.getOnRecords(this.props.records);
    let showRecordsText;
    if (this.state.activeOn && this.state.completedOn) {
      showRecordsText = 'Displaying all records';
    } else if (this.state.activeOn) {
      showRecordsText = 'Displaying active records only';
    } else if (this.state.completedOn) {
      showRecordsText = 'Displaying completed records only';
    } else {
      showRecordsText = 'No records displayed';
    }
    if (this.props.records && this.props.records.length > 0) {
      return (
        <div>
          <Row>
            <Col md={6}>
              <h5>{showRecordsText}</h5>
            </Col>
            <Col md={6} className="text-right">
              <Button size="sm" onClick={this.onActiveBtnClick}
                      color={(this.state.activeOn) ? 'primary' : 'secondary'}>Active {'(' + countRecords.on + ')'}</Button>
              <Button size="sm" onClick={this.onCompleteBtnClick}
                      color={(this.state.completedOn) ? 'primary' : 'secondary'}>Completed {'(' + countRecords.off + ')'}</Button>
              {'   '}
              {
                (this.props.user.permissionFlags.ADD === 'true') ?
                  <Button size="sm" onClick={this.newRec}
                          color='primary'>New</Button> :
                  null
              }
            </Col>
          </Row>
          {
            <div>
              <ul className="record-item top-spacer">
                <li className="center bold">
                  <h6 className="bold">Actions</h6>
                </li>
                <li className="center bold">
                  <h6 className="bold">Date on</h6>
                </li>
                <li className="center bold">
                  <h6 className="bold">Date off</h6>
                </li>
                <li className="center bold">
                  <h6 className="bold">Notes</h6>
                </li>
                <li className="center bold">
                  <h6 className="bold">Reason</h6>
                </li>
                <li className="center bold">
                  <h6 className="bold">Contact</h6>
                </li>
              </ul>
              {
                _this.props.records.map((rec, idx) => {
                  if (_this.state.activeOn && (parseInt(rec.dateOff, 10) === 0)) {
                    return _this.generateLine(rec, idx, 'on')
                  } else if (_this.state.completedOn && (parseInt(rec.dateOff, 10) > 0)) {
                    return _this.generateLine(rec, idx, 'off')
                  } else {
                    return null;
                  }
                })
              }
            </div>
          }
          {this.getEditModal()}
        </div>
      )
    } else {
      return (
        <div>
          <Row>
            <Col md={8}>
              <h5>There are no LOP records to display</h5>
            </Col>
            <Col md={4} className="right">
              {
                (this.props.user.permissionFlags.ADD === 'true') ?
                  <Button size="sm" onClick={this.newRec}
                          color='primary'>New</Button> :
                  null
              }
            </Col>
          </Row>
          {this.getEditModal()}
        </div>
      )
    }
  }

}

export default ShowRecords;



// WEBPACK FOOTER //
// ./src/views/ShowRecords.js